var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCryptoBuyPortal = function SvgCryptoBuyPortal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 206 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M111.057 18.771c-18.66 2.991-37.656 3.016-56.466 4.826-9.73.937-64.27 28.6-53.098 87.431 4.1 21.672 25.821 39.239 47.854 38.277 18.72-.818 20.782-13.153 54.143-13.853 25.333-.531 44.863 17.544 74.209 7.111 13.005-4.624 23.366-16.291 26.686-29.686 3.32-13.394-1.495-28.868-12.828-36.769-5.875-4.11-13.379-6.338-17.564-12.17-8.203-11.431 8.409-29.11 1.019-41.08-14.688-23.81-48.293-6.59-63.955-4.087z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M36.386 112.541s-19.707 4.902-2.641 11.964c17.065 7.061 96.284 14.857 125.286-1.12 0 0 19.892-.553 20.437-3.342.546-2.789-2.362-5.045-2.362-5.045l-10.087-.341s-1.857 4.02-11.151-3.283c-9.294-7.303-119.481 1.167-119.481 1.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.494 116.735a6.698 6.698 0 01-4.853 2.535c-2.642 0-1.366-2.472-.498-2.472a3.17 3.17 0 00.733-.07l1.086-.947 1.074-.96.282-.608s1.496.344 1.762-.052l.195 1.68v.326c.119.168.194.364.219.568z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.545 112.583c0 8.604-26.809 15.575-59.876 15.575-33.067 0-59.88-6.979-59.88-15.575a4.851 4.851 0 01.997-2.842c5.13-7.245 29.54-12.736 58.883-12.736 29.343 0 53.749 5.483 58.879 12.736a4.86 4.86 0 01.997 2.842z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M155.132 109.741c-5.137 7.246-29.543 12.732-58.878 12.732-29.336 0-53.744-5.483-58.881-12.732 5.127-7.245 29.538-12.736 58.88-12.736 29.344 0 53.75 5.491 58.879 12.736z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M96.419 116.738c27.003 0 48.894-3.992 48.894-8.916s-21.891-8.915-48.894-8.915-48.894 3.991-48.894 8.915c0 4.924 21.89 8.916 48.894 8.916z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.681 106.898s3.427 7.497-40.65 7.789H95.48c-11.75 0-20.249-.619-26.398-1.496h-.017c-15.74-2.243-16.031-6.273-16.031-6.273L24.588 1.334l45.643-.182L165.4.78l-26.718 106.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.012 116.603c0 .25-2.642 1.76-5.234 1.76s-1.366-2.492-.484-2.472h.88l.498-.25 1.895-.967.281-.608s1.496.344 1.763-.052l.194 1.707v.309c.118.17.189.367.207.573z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.827 116.03c.095.179.143.379.14.581 0 .249-2.642 1.759-5.234 1.759s-1.366-2.492-.484-2.472h.88l.499-.249 4.159.069.04.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.188 117.413a3.86 3.86 0 01-1.939 0c-.581-.316-.765-.555-.748-.8.018-.244.371-.952 1.762-.618 1.391.334 1.648 1.084 1.648 1.084l-.723.334zM177.494 116.735a6.714 6.714 0 01-4.853 2.535c-2.642 0-1.366-2.472-.498-2.472a3.17 3.17 0 00.733-.07l1.086-.947 3.338.06v.326c.112.17.179.365.194.568z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.112 118.196a3.874 3.874 0 01-1.937 0c-.583-.317-.768-.553-.748-.8.02-.247.369-.952 1.762-.616 1.394.337 1.683 1.047 1.683 1.047l-.76.369z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.604 87.905l2.632 26.101s1.762.636 2.547 0l1.091-20.558 3.091 20.74s1.443.932 2.333-.122l1.156-26.298s-9.222 1.897-12.85.137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.604 87.68l2.632 26.107s1.762.633 2.547 0l1.091-20.558 3.091 20.73s1.443.932 2.333-.125l1.156-26.295s-9.222 1.901-12.85.142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.852 63.21c.347.27.718.506 1.11.705a9.662 9.662 0 002.99 1.109c1.384.15 1.964 2.742 2.149 3.96.184 1.22 1.453 7.279 1.453 7.279a2.459 2.459 0 01-1.954 2.594c-2.243.73-2.186 1.092-2.186 1.092l.045 7.779s-10.107 2.455-12.836.142l.396-10.526 1.496-11.44 4.282-1.994 3.055-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.852 63.21c.347.27.718.506 1.11.705a9.662 9.662 0 002.99 1.109c1.384.15 1.964 2.742 2.149 3.96.184 1.22 1.453 7.279 1.453 7.279a2.459 2.459 0 01-1.954 2.594c-2.243.73-2.186 1.092-2.186 1.092l.045 7.779s-10.107 2.455-12.836.142l.396-10.526 1.496-11.44 4.282-1.994 3.055-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.87 62.983a2.642 2.642 0 01-3.509 1.28l-.103-.05s-2.185 3.794.942 3.346c1.658-.25 2.742-2.869 2.991-4.11l-.321-.466z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M175.583 76.053c.814-.191 1.617-.43 2.405-.713.274-.184-.397-5.15-.397-5.15s-.249 3.989-5.356 5.898c-2.492.932 1.71 2.208 1.71 2.208l1.638-2.243z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M175.09 79.316s2.759 1.02 3.305.66v6.072s-7.049-4.569-7.049-5.281c0-.713-5.391-.878-5.391-.878v-1.662l8.185-.967s1.77-1.536.95 2.056z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.558 75.964s0 2.492-.379 3.202-.618-1.76-.618-1.76l.997-1.442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.029 59.95l-.07 1.295c-.035.616-.077 1.354-.107 1.97a4.135 4.135 0 01-1.261 2.756 4.681 4.681 0 01-1.54 1.047.822.822 0 01-1.045-.498.848.848 0 01-.02-.476c.157-.468.252-.954.284-1.446.01-.184.01-.37 0-.553a5.326 5.326 0 00-.122-1.015c-.473-1.191 3.37-2.866 3.826-3.063l.055-.017z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.988 59.962c-.204.556-.249 1.66-1.089 2.742-.382.498-1.408 1.622-2.627 1.891.012-.184.012-.369 0-.553a5.326 5.326 0 00-.122-1.014c-.461-1.182 3.382-2.87 3.838-3.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.227 52.517a4.175 4.175 0 00-3.931 4.69c.133 1.695.571 3.35 1.294 4.888 1.366 2.323 4.81.414 5.356-.546.546-.96 2.642-5.279 1.762-6.502-.573-.803-2.238-2.617-4.481-2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.584 50.9l.688.36a2.65 2.65 0 00-2.158 1.02 3.514 3.514 0 00-1.022 2.43l1.206-.573s-.087 1.478 2.186 1.593c2.273.114 4.686.201 4.686.201l-.775-1.064s1.435.573 1.664 1.092c.222.834.382 1.684.477 2.542 0 0 .573-1.45.792-1.134.219.317-.249 1.638-.546 1.937-.296.299-.249 1.161-.274 1.231-.025.07 1.411-1.117 1.481-1.523.069-.406 1.495-4.549.573-5.411l.573-.045a2.744 2.744 0 00-1.119-.431s-3.746-4.89-8.432-2.226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.515 65.966s-1.762.773-1.994 4.237a33.78 33.78 0 01-1.231 6.598 39.944 39.944 0 01-4.011.202l1.957 1.495a5.914 5.914 0 002.492 1.117l1.349.299 1.438-13.948z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.051 77.863a.788.788 0 010 .097.725.725 0 01-.748.626l-13.21-.748a.689.689 0 01-.326-.097.698.698 0 01-.379-.387l-2.884-8.225a.722.722 0 01.095-.66.727.727 0 01.601-.3l9.169.16a.725.725 0 01.678.528l2.009 7.216a.723.723 0 00.591.519l3.753.555a.718.718 0 01.651.716z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.051 77.863a.788.788 0 010 .097.725.725 0 01-.748.626l-13.21-.748a.689.689 0 01-.326-.097.698.698 0 01-.379-.387l-2.884-8.225a.722.722 0 01.095-.66.727.727 0 01.601-.3l9.169.16a.725.725 0 01.678.528l2.009 7.216a.723.723 0 00.591.519l3.753.555a.718.718 0 01.651.716z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.464 77.45a.998.998 0 01-.658 0 2.564 2.564 0 01-.628-.218c-.362-.197-1.149-.92-1.887-.713a5.486 5.486 0 01-1.994.105c-.272-.062-.272-.134-.536-.105-.264.03-.249-.319-.249-.319a11.047 11.047 0 012.56-1.216 7.689 7.689 0 012.644.538l.573.33.035.017.309.18s.013 1.263-.169 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.775 75.004l-1.217-.66s-.201.326-.079.498c.065.085.139.162.222.23.349-.098.715-.12 1.074-.068z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.471 78.03a3.411 3.411 0 001.834 1.246c1.321.421 3.691-.441 3.691-.441s.776-.352.633-.431c-.142-.08-3.945-.23-3.945-.23l-2.213-.144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.174 115.891s.882.448.934 1.144l.07.378s3.308-.635 3.684-1.383l-.159-1.161a1.713 1.713 0 01-1.516.545c-.782-.236-.633-.747-.633-.747l-2.38 1.224zM173.178 116.885l-.289-.15 2.158-1.926s.466 1.126 2.106.219l.192 1.127a7.583 7.583 0 01-3.452 2.086 1.742 1.742 0 00-.715-1.356z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M166.174 115.891s.882.448.934 1.144l.07.378s3.308-.635 3.684-1.383l-.159-1.161a1.713 1.713 0 01-1.516.545c-.782-.236-.633-.747-.633-.747l-2.38 1.224z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M173.178 116.885l-.289-.15 2.158-1.926s.466 1.126 2.106.219l.192 1.127a7.583 7.583 0 01-3.452 2.086 1.742 1.742 0 00-.715-1.356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.357 78.227l-4.984-.264-4.669-.25a.718.718 0 01-.326-.371l-.282-.818-1.024-2.93-1.551-4.452a.763.763 0 01.115-.25l4.591.06 4.853.065a.56.56 0 01.498.484c.07.458 1.994 7.796 1.994 7.796a1.464 1.464 0 00.785.93z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M169.357 78.227l-4.984-.264-4.669-.25a.718.718 0 01-.326-.371l-.282-.818-1.024-2.93-1.551-4.452a.763.763 0 01.115-.25l4.591.06 4.853.065a.56.56 0 01.498.484c.07.458 1.994 7.796 1.994 7.796a1.464 1.464 0 00.785.93z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M169.336 76.746s.626 1.364 0 1.478l4.018.167s.441-.105.396-.431a1.335 1.335 0 00-.396-.65l-3.831-.5-.187-.064z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.322 77.95c.095-.022.135-.204.09-.409-.045-.204-.162-.351-.249-.329-.088.023-.135.205-.088.409.048.204.157.351.247.329z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.562 78.227l-4.053-.167-4.668-.25a.705.705 0 01-.327-.378l-.282-.818 8.659.202c.112.516.341.998.671 1.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.479 89.181s.433 3.52 1.393 4.25l-.299-4.135-1.094-.115zM176.711 88.097l.414 26.051 1.311-26.417-1.725.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.777 104.921l-.122.092c-.097.073-.204.16-.322.25a10.64 10.64 0 00-.97.912c-.889.952-1.427 1.909-1.432 2.821-.002.416.116.824.341 1.174l.023-.184-1.446 1.391-.115.109.12.105 3.512 3.168.07.062.087-.037 4.185-1.76h-.105l.072.033.21.087.747.314a92.365 92.365 0 003.228 1.256c1.603.583 2.841.96 3.58 1.057l-.123-.19-1.86 5.853-.042.137.135.047 3.208 1.117-.1-.135.045 1.673h.294l-.045-1.673v-.102l-.095-.032-3.207-1.117.092.182 1.864-5.847.055-.167-.175-.023c-.707-.094-1.931-.466-3.516-1.044l-.82-.304c-.795-.302-1.61-.626-2.398-.947l-.748-.314-.207-.088-.072-.03-.057-.024-.058.024-4.184 1.76.154.025-3.524-3.158v.214l1.443-1.39.087-.083-.065-.102a1.851 1.851 0 01-.294-1.014c0-.82.499-1.72 1.354-2.622a10.519 10.519 0 011.253-1.139l.117-.088-.174-.249zM58.041 118.368l.184.03.534.082c.576.092 1.226.192 1.941.302 2.04.309 4.168.618 6.279.907 1.072.148 2.11.285 3.113.411 4.79.608 8.412.942 10.403.91h.097l.038-.09.997-2.41-.145.09h.077l.23.015.84.055c.887.054 1.83.112 2.784.164.78.042 1.532.08 2.243.112 2.23.102 3.975.147 5.044.115l-.151-.135.468 6.959v.14h.775l1.68-.023c1.745-.027 3.475-.067 5.097-.119 4.06-.132 6.692-.324 7.33-.603l.095-.043v-.102l-.185-2.789-.064.132 4.925-3.24-.073.025h.137l.387-.03 1.373-.105c1.423-.117 2.844-.249 4.172-.391 2.829-.309 4.836-.631 5.683-.962l-.194-.102.713 2.829.019.082.083.025 8.182 2.323h.073l6.879-1.496-.122-.03 1.495 1.207.184-.227-1.495-1.207-.055-.044-.067.015-6.882 1.495h.073l-8.185-2.325.102.107-.713-2.852-.043-.162-.154.06c-.813.319-2.809.641-5.608.942-1.323.145-2.742.277-4.165.392-.498.042-.957.077-1.371.107l-.383.027h-.138l-.069.025-4.925 3.24-.073.045v.087l.185 2.79.087-.145c-.583.249-3.24.449-7.228.578-1.62.055-3.355.092-5.092.12l-1.677.022h-.636l.147.137-.466-6.961v-.142h-.115c-1.059.03-2.796-.015-5.022-.115-.718-.032-1.47-.072-2.243-.114-.954-.053-1.897-.108-2.784-.162l-.837-.055-.23-.015h-.184l-.04.097-.997 2.413.132-.093c-1.971.033-5.585-.301-10.36-.907-.998-.127-2.042-.264-3.111-.411a422.026 422.026 0 01-6.276-.907c-.713-.108-1.364-.21-1.94-.299l-.53-.085-.187-.028-.065.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.55 127.922l-2.94-3.916-.05-.067h-.07c-1.06.122-4.611-.105-9.84-.583l-2.196-.207a675.2 675.2 0 01-5.608-.564l-1.745-.187-.48-.052-.17-.017h-.058l-.044.032-3.29 2.393.172.237 3.285-2.376-.103.028.17.017.48.052 1.746.187c1.834.192 3.738.384 5.608.566l2.198.205c5.264.481 8.813.71 9.902.583l-.134-.058 2.94 3.906.228-.179zM150.789 118.974l.062-3.036-.077.127.159-.092a10.212 10.212 0 001.68-1.261c1.027-.958 1.698-2.019 1.83-3.166l-.135.13 1.613-.122-.023-.294-1.612.124h-.12l-.015.12c-.125 1.067-.748 2.071-1.745 2.991a9.62 9.62 0 01-1.223.962 5.299 5.299 0 01-.404.249 2.45 2.45 0 01-.15.087l-.075.04v.1l-.062 3.036.297.005zM48.139 103.119c-.03.018-.083.05-.155.1-.122.08-.25.174-.406.281-.431.324-.837.679-1.214 1.065-1.46 1.475-2.15 3.1-1.627 4.795l.279-.084c-.484-1.571.164-3.099 1.557-4.504a9.899 9.899 0 011.728-1.391l-.162-.262zM38.049 108.485c-.09.143-.164.296-.22.456a3.86 3.86 0 00.03 2.64c.471 1.381 1.613 2.809 3.564 4.252a34.914 34.914 0 005.65 3.009l-.081-.09 1.011 3.163.28-.09-1.012-3.15-.023-.065-.062-.025a34.47 34.47 0 01-5.596-2.991c-1.899-1.406-2.99-2.784-3.452-4.105a3.563 3.563 0 01-.035-2.443 2.367 2.367 0 01.188-.391l-.242-.17zM150.657 106.437c0 .012.027.032.052.067.025.035.092.12.144.192a7 7 0 01.444.708c.583 1.079.815 2.176.499 3.193-.389 1.258-1.596 2.298-3.809 3.033a291.93 291.93 0 01-8.225 2.615c-.831.249-1.556.462-2.176.64l-.558.157-.189.052.142.038-2.096-2.049-.05-.05h-.07l-4.713.556.117.037-1.496-1.365-.196.216 1.495 1.364.05.047h.08l4.713-.553-.12-.04 2.096 2.049.06.06.082-.023.19-.052.561-.16c.618-.177 1.345-.391 2.178-.64a297.133 297.133 0 008.225-2.617c2.295-.763 3.576-1.867 3.988-3.226.339-1.106.092-2.278-.526-3.419a6.984 6.984 0 00-.461-.748 3.342 3.342 0 00-.155-.204.366.366 0 00-.06-.075l-.216.197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.463 77.449a.997.997 0 01-.658 0c.61-.154.481-1.598.481-1.598l.035.018.309.18s.015 1.263-.167 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.823 91.008l-.706 23.215c.241-.01.474-.085.676-.217l1.091-20.575-1.061-2.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.666 114.766l-18.825-.643c-.225-.015-5.379-.665-12.086-1.58-2.61-.356-11.891-3.121-12.711-5.621L24.588 1.334l45.643-.182 26.42 113.535.015.079z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M161.217 68.965l-.154.356-2.642 4.561-.352-.286-1.548-4.452a.764.764 0 01.115-.25l4.581.07z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 95.539,
    y1: 114.699,
    x2: 94.993,
    y2: 0.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 151.798,
    y1: 106.284,
    x2: 187.587,
    y2: 96.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E1FD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#66DAF6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#58A1BC",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4D758F",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#45566F",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#40435C",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3F3D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 172.799,
    y1: 76.028,
    x2: 148.096,
    y2: 77.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 170.961,
    y1: 63.506,
    x2: 175.029,
    y2: 63.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2860.26,
    y1: 1985.09,
    x2: 2952.71,
    y2: 2308.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 5977.3,
    y1: 4344.76,
    x2: 6277.72,
    y2: 4344.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 11800.4,
    y1: 3579.6,
    x2: 11816.6,
    y2: 2833.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4332.58,
    y1: 1273.37,
    x2: 4482.93,
    y2: 1273.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1089.89,
    y1: 415.834,
    x2: 1097.05,
    y2: 415.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4214.11,
    y1: 739.034,
    x2: 4367.15,
    y2: 739.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 169.573,
    y1: 117.521,
    x2: 167.749,
    y2: 114.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00272E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B9EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3332,
    y1: 2321.64,
    x2: 3298.87,
    y2: 2270.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00272E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B9EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 754.211,
    y1: 861.161,
    x2: 772.964,
    y2: 886.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 17635.4,
    y1: 71648.7,
    x2: 17239.7,
    y2: 19787.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 156.512,
    y1: 71.387,
    x2: 161.217,
    y2: 71.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B9EB"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .78)",
    d: "M0 0h205.425v148.561H0z"
  })))));
};
export default SvgCryptoBuyPortal;